import React, { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import * as AppRoutes from '../../common/routeNames';
import { useUserState } from '../../context/UserContext';
import { useStudy } from '../../context/StudyContext';
import { normalizeClaimCode } from '../../common/apiStudyUtilities';
import { debugLog } from '../../common/debugUtilities';

/**
 * Landing route for the enrolment letter's link, https://app.cribsy.ai/claim/<code> (decision D20). Remembers the
 * code in the study context, then sends the parent to sign-in, registration or the dashboard; the dashboard opens
 * the claim dialog with the code filled in as soon as the account is registered.
 */
export default function ClaimLink() {
  const { code } = useParams();
  const user = useUserState();
  const { setPendingCode } = useStudy();
  const normalized = normalizeClaimCode(code);

  useEffect(() => {
    if (normalized) {
      debugLog('[claim-link] code received');
      setPendingCode(normalized);
    }
  }, [normalized, setPendingCode]);

  if (!user?.isAuthenticated) return <Redirect to={AppRoutes.SIGN_IN} />;
  if ((user?.authLevel ?? -1) < 0) return <Redirect to={AppRoutes.USER_SETTINGS} />;
  return <Redirect to={AppRoutes.DASHBOARD} />;
}
